import { render } from "./StatisticsPortalUniqueVisitsCountTab.vue?vue&type=template&id=2208a50e&ts=true"
import script from "./StatisticsPortalUniqueVisitsCountTab.vue?vue&type=script&lang=ts"
export * from "./StatisticsPortalUniqueVisitsCountTab.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__